import {
  IWordGamesItem,
  IWordGamesTask,
  IWordGamesTaskSession
} from 'common/modules/ReactShared';
import { useCallback, useMemo } from 'react';

type tUseUncompletedGamesArgs = {
  task: IWordGamesTask;
  taskSession?: IWordGamesTaskSession;
};

type tUseUncompletedGamesResult = {
  uncompletedGames: IWordGamesItem[];
};

const useUncompletedGames = (
  args: tUseUncompletedGamesArgs
): tUseUncompletedGamesResult => {
  const { taskSession, task } = args;
  const { items } = task;

  const hasGameItemCompletedSession = useCallback(
    (item: IWordGamesItem): boolean => {
      const itemSession = taskSession?.taskItemSessions.find(
        (sessionItem) => sessionItem.taskItemId === item.id
      );
      return itemSession?.completed ?? false;
    },
    [taskSession?.taskItemSessions]
  );

  const uncompletedGames = useMemo(
    () =>
      items.filter((item: IWordGamesItem) => {
        return item.enabled && !hasGameItemCompletedSession(item);
      }),
    [items, hasGameItemCompletedSession]
  );

  return {
    uncompletedGames
  };
};

export { useUncompletedGames };
export type { tUseUncompletedGamesResult, tUseUncompletedGamesArgs };
